import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { useEffect } from 'react'

type Props = {
  filesLength?: number
  cancelButton: React.ReactNode
  confirmCb: () => void
  onDelete: () => void
}

const AttachedFilesDialog: React.FC<Props> = ({
  filesLength = 1,
  cancelButton,
  confirmCb,
  onDelete,
}) => {
  useEffect(() => {
    const onDocumentKeydown = (e: KeyboardEvent) => {
      if (e.code === 'Enter' || e.code === 'Backspace') {
        onDeleteClick()
      }
    }

    document.addEventListener('keydown', onDocumentKeydown)

    return () => {
      document.removeEventListener('keydown', onDocumentKeydown)
    }
  })

  const onDeleteClick = () => {
    onDelete()

    confirmCb()
  }

  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">
        Delete {filesLength} file{filesLength > 1 ? 's' : ''}
      </div>

      <div className="System-dialog__description">
        <p>
          Are you sure you want to delete these attachments? This action is
          irreversible.
        </p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="Delete"
            onClick={onDeleteClick}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}

export default AttachedFilesDialog
